
<template>
  <div class="footerBottom">
    <div class="flx-center">
      <div class="platformBackground"  :style="{ background: 'url(' + $ossUrl + 'images/战略合作平台.jpg) no-repeat center' }"></div>
    </div>

    <div class="platform">
      <div class="container" >
          <div >
            <div class=" button-group">
            <div class="button-group-item"  style="position: absolute;top:800px;">
              <el-button
               v-for="(item, index) in buttons"
               :key="index"
               :class="{ 'active': activeIndex === index }"
               @click="setActive(item,index)"
             >
               <div class="btn-text" style="">
                {{ item.label }}
              </div>
             </el-button>
            </div>
           </div>
          </div>
         <div style="margin-top: 148px;">
          <div class="platformSearch">
            <div>
            查询方法：点开需要查找国家的地址清单，按Ctrl+F，输入已知信息，，即可快速找到
            </div>
            <div>
              示例：点击“美国亚马逊FBA仓库地址清单”→ 按Ctrl+F → 在查找框输入“PHX3”，即可找到该地址。
            </div>
          </div>
          <div>
            <div class="platTableTitle">美国亚马逊仓库地址清单</div>
            <div class="platTable flx-center">
              <el-table  :cell-style="{background:'#fff'}" :data="tableData_American" style="width: 100%">
                <el-table-column prop="fbacode" label="FBA Code" :show-overflow-tooltip="true" ></el-table-column>
                <el-table-column prop="address" width="300" label="地址" :show-overflow-tooltip="true" ></el-table-column>
                <el-table-column prop="city" label="City" :show-overflow-tooltip="true" ></el-table-column>
                <el-table-column prop="state" label="State" :show-overflow-tooltip="true" ></el-table-column>
                <el-table-column prop="zip" label="Zip" :show-overflow-tooltip="true" ></el-table-column>
              </el-table>
            </div>
            <el-button @click="goClient" class="getMore" >查看更多</el-button>

          </div>
          <div>
            <div class="platTableTitle">亚马逊仓库地址清单</div>
            <div class="platTable flx-center">
              <el-table :cell-style="{background:'#fff'}" :data="tableData" style="width: 100%">
                <el-table-column prop="fbacode" label="FBA Code" :show-overflow-tooltip="true" ></el-table-column>
                <el-table-column prop="address" width="300" label="地址" :show-overflow-tooltip="true" ></el-table-column>
                <el-table-column prop="city"  width="250" label="City" :show-overflow-tooltip="true" ></el-table-column>
                <el-table-column prop="state"  width="250"  label="State" :show-overflow-tooltip="true" ></el-table-column>
                <el-table-column prop="zip" label="Zip" :show-overflow-tooltip="true" ></el-table-column>
                <el-table-column prop="country_name" label="国家" :show-overflow-tooltip="true" ></el-table-column>

              </el-table>
            </div>
            <el-button @click="goClient" class="getMore" >查看更多</el-button>

          </div>
         </div>
        </div>
      
    </div>
  </div>
</template>
<script>


/**
 * Index-1 component
 */
export default {
  name:"platform",
  components: {
  },
  data(){
    return {
      activeName: 'second',
      activeIndex: 0, // 默认选中第一个按钮
      buttons: [
        { label: '亚马逊仓库地址',transportMode:'OCEAN' },
        // { label: '仓库地址分布图',transportMode:'AIR' },
        { label: 'AMAZON注册',transportMode:'RAIL' }
      ],
      tableData_American: 
      [
          {
        fbacode: 'VUI4',
        address: '303 Nelson Avenue',
        city: 'NEOSHO',
        state: 'MO',
        zip: '64850'
          },
          {
        fbacode: 'SUAW',
        address: '8870 Boggy Creek Rd',
        city: 'Orlando',
        state: 'FL',
        zip: '32824'
          },
          {
        fbacode: 'VUGR',
        address: '1565 N Mac Arthur Dr.',
        city: 'TRACY',
        state: 'CA',
        zip: '95376'
          },
          {
            fbacode: 'SUEJ',
            address: '1565 N Mac Arthur Dr.',
            city: 'TRACY',
            state: 'IL',
            zip: '60131'
          },
          {
            fbacode: 'PAE2',
            address: '4620 172ND ST NE',
            city: 'ARLINGTON',
            state: 'WA',
            zip: '98223-7738'
          },
          {
            fbacode: 'ELP1',
            address: '12101 EMERALD PASS DR',
            city: 'EL PASO',
            state: 'TX',
            zip: '79928-7808'
          },
          {
            fbacode: 'MAE4',
            address: '4101 W 95th St',
            city: 'Oak Lawn',
            state: 'IL',
            zip: '60453'
          },
          {
            fbacode: 'HNJ2',
            address: '13905 Crayton Blvd',
            city: 'Hagerstown',
            state: 'MD',
            zip: '21742'
          },
          {
            fbacode: 'HDS9',
            address: '200 SE 37TH ST',
            city: 'GRIMES',
            state: 'IA',
            zip: '50111-5196'
          },
          {
            fbacode: 'CIN1',
            address: '241 Calhoun St',
            city: 'Cincinnati',
            state: 'OH',
            zip: '45219'
          }, //10
          {
            fbacode: 'UOH4',
            address: '4401 Equity Dr',
            city: 'COLUMBUS',
            state: 'OH',
            zip: '43228'
          },
          {
            fbacode: 'VUJL',
            address: '6710 OAKLEY INDUSTRIAL BLVD',
            city: 'UNION CITY',
            state: 'GA',
            zip: '30291-5125'
          },
          {
            fbacode: 'TTN6',
            address: '942 MEMORIAL PKWY',
            city: 'PHILLIPSBURG',
            state: 'NJ',
            zip: '8865'
          },
          {
            fbacode: 'ABE5',
            address: '100 Quality Circle',
            city: 'Harrisburg',
            state: 'PA',
            zip: '17112'
          },
          {
            fbacode: 'CAK1',
            address: '290 E Exchange Street',
            city: 'Akron',
            state: 'OH',
            zip: '44304'
          },
          {
            fbacode: 'LGA6',
            address: '8003 Industrial Avenue',
            city: 'Cartaret',
            state: 'NJ',
            zip: '07008-3529'
          },
          {
            fbacode: 'EWR5',
            address: '301 Blair Rd.',
            city: 'Avenel',
            state: 'NJ',
            zip: '7001'
          },
          {
            fbacode: 'PISC',
            address: '271 Omega Parkway',
            city: 'Shepherdsville',
            state: 'KY',
            zip: '40165'
          },
          {
            fbacode: 'DEN4',
            address: '4222 Integration Loop',
            city: 'COLORADO SPRINGS',
            state: 'CO',
            zip: '80916-5766'
          },
          {
            fbacode: 'SUOY',
            address: '1728 Smallman St.',
            city: 'Pittsburgh',
            state: 'PA',
            zip: '15222'
          },//20
          {
            fbacode: 'MMU9',
            address: '698 Rte. 46 W.',
            city: 'TETERBORO',
            state: 'NJ',
            zip: '7608'
          },
          {
            fbacode: 'INY3',
            address: '300 Park Ave',
            city: 'NEW YORK',
            state: 'NY',
            zip: '10022'
          },
          {
            fbacode: 'SUOY',
            address: '1728 Smallman St.',
            city: 'Pittsburgh',
            state: 'PA',
            zip: '15222'
          },
          {
            fbacode: 'VUQO',
            address: '1800 Steward Rd',
            city: 'Rochelle',
            state: 'IL',
            zip: '15222'
          },
          {
            fbacode: 'VUI5',
            address: '13133 Innovation Way',
            city: 'VICTORVILLE',
            state: 'CA',
            zip: '92395'
          },
          {
            fbacode: 'ONT9',
            address: '2125 West San Bernardino Ave',
            city: 'Redlands',
            state: 'CA',
            zip: '92374'
          },
          {
            fbacode: 'INY7',
            address: '11 W. 42nd St.',
            city: 'New York',
            state: 'NY',
            zip: '10036'
          },
          {
            fbacode: 'SUHQ',
            address: '4635 NAUTILUS CT S',
            city: 'Boulder',
            state: 'CO',
            zip: '80301'
          },
          {
            fbacode: 'INY1',
            address: '200 Vesey St',
            city: 'NEW YORK',
            state: 'NY',
            zip: '10281'
          },
          {
            fbacode: 'ASH1',
            address: '267 LOWELL RD',
            city: 'HUDSON',
            state: 'NH',
            zip: '03051-4937'
          },
          {
            fbacode: 'SUXC',
            address: '345 Boren Ave N',
            city: 'Seattle',
            state: 'WA',
            zip: '98109'
          },//30
          {
            fbacode: 'MKE5',
            address: '11211 Burlington Rd',
            city: 'Kenosha',
            state: 'WI',
            zip: '53144'
          },
          {
            fbacode: 'KCA6',
            address: '1553 N Alder Ave',
            city: 'RIALTO',
            state: 'CA',
            zip: '92376-3024'
          },
          {
            fbacode: 'UTX4',
            address: 'PO Box 80387',
            city: 'Seattle',
            state: 'WA',
            zip: '98108'
          },
          {
            fbacode: 'HTN3',
            address: '555 EXPRESSWAY PARK DR',
            city: 'NASHVILLE',
            state: 'TN',
            zip: '37210-2845'
          },
          {
            fbacode: 'MAF7',
            address: '389 Easton Road',
            city: 'WARRINGTON',
            state: 'PA',
            zip: '18976'
          },
          {
            fbacode: 'BDL6',
            address: '120 County Line Drive',
            city: 'CROMWELL',
            state: 'CT',
            zip: '6416'
          },
          {
            fbacode: 'SUPG',
            address: '3725 Swenson Rd',
            city: 'St Charles',
            state: 'IL',
            zip: '60174'
          },
          {
            fbacode: 'KRB4',
            address: '4501 PATTERSON AVE',
            city: 'PERRIS',
            state: 'CA',
            zip: '92571-9722'
          },
          {
            fbacode: 'BFC1',
            address: '380 Middlesex Ave',
            city: 'CARTERET',
            state: 'NJ',
            zip: '07008-3445'
          },
          {
            fbacode: 'JAX3',
            address: '13333 103rd Street',
            city: 'Jacksonville',
            state: 'FL',
            zip: '32221'
          },//40
          {
            fbacode: 'VUAQ',
            address: '6201 Seaforth St',
            city: 'BALTIMORE',
            state: 'MD',
            zip: '21224'
          },
          {
            fbacode: 'SULA',
            address: '1380 Stonegate Way',
            city: 'Ferndale',
            state: 'WA',
            zip: '98248'
          },
          {
            fbacode: 'ORD3',
            address: '24101 S Frontage Rd W',
            city: 'CHANNAHON',
            state: 'IL',
            zip: '60410'
          },
          {
            fbacode: 'PIN1',
            address: '5510 EXPLORATION DR',
            city: 'Indianapolis',
            state: 'IN',
            zip: '46241-9007'
          },
          {
            fbacode: 'TFL5',
            address: '8792 Ely Rd',
            city: 'PENSACOLA',
            state: 'FL',
            zip: '32514'
          },
          {
            fbacode: 'SUAP',
            address: '23824 W. Andrew Rd.',
            city: 'Plainfield',
            state: 'IL',
            zip: '60585'
          },
          {
            fbacode: 'UIN1',
            address: '710 S. Girls School Road',
            city: 'Indianapolis',
            state: 'IN',
            zip: '46231-1132'
          },
          {
            fbacode: 'SULD',
            address: '2020 Prairie Ln',
            city: 'Eau Claire',
            state: 'WI',
            zip: '54703'
          },
          {
            fbacode: 'SUJB',
            address: '706 North Diamond Bar Blvd',
            city: 'Diamond Bar',
            state: 'CA',
            zip: '91765'
          },
          {
            fbacode: 'SCK6',
            address: 'Grant Line Road',
            city: 'Tracy',
            state: 'CA',
            zip: '95304'
          }
      ],
      tableData: 
      [
          {
        fbacode: 'YEG1',
        address: '1440 39 AVE',
        city: 'Nisku',
        state: 'AB',
        zip: 'T9E 0B4',
        country_name:'加拿大'
          },
          {
        fbacode: 'YOW3',
        address: '222 Citigate Drive',
        city: 'Nepean (Barrhaven)',
        state: 'ON',
        zip: 'K2J 7C7',
        country_name:'加拿大'
          },
          {
        fbacode: 'YYZ2',
        address: '2750 Peddie Rd. ',
        city: 'ON',
        state: 'Milton',
        zip: 'L9T 0K1',
        country_name:'加拿大'

          },
          {
            fbacode: 'YVR4',
            address: '4189 Salish Sea Way',
            city: 'Tsawwassen',
            state: 'BC',
            zip: 'V4M 0B9',
            country_name:'加拿大'

          },
          {
            fbacode: 'YXU1',
            address: '11884 Sunset Dr.',
            city: 'London',
            state: 'ON',
            zip: 'N5P 0G9',
            country_name:'加拿大'

          },
          {
            fbacode: 'YHM1',
            address: '110 Aeropark Blvd.',
            city: 'MOUNT HOPE',
            state: 'ON',
            zip: 'L0R 1W1',
            country_name:'加拿大'

          },
          {
            fbacode: 'YYZ6',
            address: '8050 Heritage Road',
            city: 'Brampton',
            state: 'ON',
            zip: 'L6Y 0C9',
            country_name:'加拿大'

          },
          {
            fbacode: 'YOW1',
            address: '5225 Boundary Road',
            city: 'Navan',
            state: 'ON',
            zip: 'K4B 0L3 ',
            country_name:'加拿大'

          },
          {
            fbacode: 'YYC1',
            address: '293069 Colonel Robertson Way',
            city: 'Calgary',
            state: 'AB',
            zip: 'T4A 1C6',
            country_name:'加拿大'

          },
          {
            fbacode: 'YXX2',
            address: '16131 Blundell Road',
            city: 'Richmond',
            state: 'BC',
            zip: 'V6W 0A3',
            country_name:'加拿大'

          }, //10
          {
            fbacode: 'YYC4',
            address: '6915 108 Ave SE',
            city: 'Calgary',
            state: 'AB',
            zip: 'T2C 5G2',
            country_name:'加拿大'

          },
          {
            fbacode: 'YYZ4',
            address: '8050 Heritage Road',
            city: 'Brampton',
            state: 'ON',
            zip: 'L6Y 0C9',
            country_name:'加拿大'

          },
          {
            fbacode: 'YEG2',
            address: '27383 92 Ave',
            city: 'Acheson',
            state: 'AB',
            zip: 'T7X 2X2',
            country_name:'加拿大'

          },
          {
            fbacode: 'YYZ9',
            address: '6351 Steeles Ave E',
            city: 'Scarborough',
            state: 'ON',
            zip: 'M1X 1N5',
            country_name:'加拿大'

          },
          {
            fbacode: 'YYZ3',
            address: '7995 Winston Churchill Blvd.',
            city: 'Brampton',
            state: 'ON',
            zip: 'L6Y 5Z4',
            country_name:'加拿大'

          },
          {
            fbacode: 'YYZ1',
            address: '6363 Millcreek Drive',
            city: ' Mississauga',
            state: 'ON',
            zip: 'L5N 1L8',
            country_name:'加拿大'

          },
          {
            fbacode: 'YVR2',
            address: '450 Derwent PL Delta',
            city: 'Delta',
            state: 'BC',
            zip: 'V3M 5Y9',
            country_name:'加拿大'

          },
          {
            fbacode: 'YVR3',
            address: '109 Braid Street ',
            city: 'New Westminster',
            state: 'BC',
            zip: 'V3L5H4',
            country_name:'加拿大'

          },
          {
            fbacode: 'YOO1',
            address: '789 Salem Rd',
            city: 'Ajax',
            state: 'ON',
            zip: 'L1Z 0J2',
            country_name:'加拿大'

          },
          {
            fbacode: 'YYZ7',
            address: '12724 Coleraine Drive',
            city: 'Bolton',
            state: 'ON',
            zip: 'L7E 4L8',
            country_name:'加拿大'

          },//20
          {
            fbacode: 'YYC6',
            address: '9705 68 ST SE',
            city: 'Calgary',
            state: 'AB',
            zip: 'T2C 5V8',
            country_name:'加拿大'

          },
          {
            fbacode: 'YVR1',
            address: '450 Derwent PL Delta',
            city: 'Vancouver',
            state: 'British Columbia',
            zip: 'V3M 5Y9',
            country_name:'加拿大'

          },
          {
            fbacode: 'YYC1-1',
            address: 'Col Robertson Wy and Crossiron Blvd',
            city: 'Calgary',
            state: 'AB',
            zip: 'T0M 0E0',
            country_name:'加拿大'

          },
          {
            fbacode: 'YUL2',
            address: '3000 Rue Louis A Amos',
            city: 'Lachine',
            state: 'QC',
            zip: 'H8T 3P8',
            country_name:'加拿大'

          },//加拿大
          {
            fbacode: 'SBOB',
            address: 'Shree Sai Dhara Complex, W/N. I-2, Opp RK petrol pump, Nr. Shagrila resorts, Mumbai Nasik highway, Kuksa (Borivali), Bhiwandi',
            city: 'Maharashtra ',
            state: '',
            zip: '421302',
            country_name:'印度'
            
          },
          {
            fbacode: 'SCCB',
            address: 'Taki road, Pirgacha Dist 24 Pgns(North),P.S.Duttapukur',
            city: 'WB',
            state: '',
            zip: '700124',
            country_name:'印度'

          },
          {
            fbacode: 'SBOE',
            address: 'Sai Dhara Complex, Warehouse No I-1, Next to Shangrila Resort, Mumbai Nashik Highway, NH#3, Kukse-Borivalli Village, District Thane. Bhiwandi',
            city: 'Maharashtra',
            state: '',
            zip: '421302',
            country_name:'印度'

          },
          {
            fbacode: 'SHYA',
            address: 'First and second Floors building bearing H.No.8-1-366/1,Tolichowki',
            city: 'Telangana',
            state: '',
            zip: '500008',
            country_name:'印度'

          },
          {
            fbacode: 'SHYB-',
            address: 'SY. NOs 241-244, 275-284, Penjerla (V), Kottur (M), Mahabubnagar dist., Hyderabad',
            city: 'Telangana',
            state: '',
            zip: '509228',
            country_name:'印度'

          },
          {
            fbacode: 'SBOC',
            address: 'ADANI LOGISTICS LTD, Antariksh Logidrome ,Warehouse A4, Village :Sape- Aamne,Padgha- Kalyan Road, Post- Padgha,  Bhiwandi',
            city: 'Maharashtra',
            state: '',
            zip: '421101',
            country_name:'印度'

          },
          {
            fbacode: 'BOM6',
            address: 'Building 1, SR.NO. 4(PART), SR.NO.5 (PART), SR.NO.6 (PART), SR.NO.20A (PART) CTS NO. 131, VILLAGE WADHWAN, KANDIVALI (EAST), TALUKA BORIVALI',
            city: 'Maharashtra',
            state: '',
            zip: '400101',
            country_name:'印度'

          },
          {
            fbacode: 'DEL2',
            address: 'Unit No.1, Khewat/Khata No. 373/400, Mustatil No. 31, Kila No 14/2, Village Tauru, Mewat',
            city: 'Haryana',
            state: '',
            zip: '122105',
            country_name:'印度'

          },
          {
            fbacode: 'BOM1',
            address: 'Building A, F & H, Prathamesh Complex, Saravali Village, Opp. Hotel Vatika, Near Kalyan Bhiwandi Junction, Bhiwandi ',
            city: 'Maharashtra',
            state: '',
            zip: '421302',
            country_name:'印度'

          },
          {
            fbacode: 'SIDA',
            address: 'Yusen Logistics (India) Pvt at Survey Number 2/4/1, 2/2/2, 2/2/2, 2/1/2, 2/2/3, 2/3/2, Village Pipliya Kumhar, MR-11; Behind METRO Cash n Carry Store, Tehsil and District Indore',
            city: 'Madhya Pradesh',
            state: '',
            zip: '453771',
            country_name:'印度'

          },//10
          {
            fbacode: 'MAA5',
            address: '​Central Warehouse, 1, Arcot Road, Virugambakkam, Chennai',
            city: 'TamilNadu',
            state: '',
            zip: '600092',
            country_name:'印度'

          },
          {
            fbacode: 'SBOA',
            address: 'DHL Supply Chain India Pvt. Ltd., K-Square, Kurund Village, Opp. Oye Punjabi Restaurant',
            city: 'Bhiwandi',
            state: '',
            zip: '421101',
            country_name:'印度'

          },
          {
            fbacode: 'SAMB',
            address: 'Crystal Indus Logistics Park , National Highway 8th, Bhayla village, Survey No-78/79, Bawla Taluka, District Ahmedabad',
            city: 'Gujarat',
            state: '',
            zip: '382220',
            country_name:'印度'

          },
          {
            fbacode: 'SDEC',
            address: 'Transport Corporation of India,Khasara No. 4/21 MIN, 22 MIN, 8/1,2,3, MIN, 4 MIN, 5, MIN, 8 MIN, 9/1 MIN, 10/1, 12/2, 13/1, 9/5, 6/1/1, Pataudi Road, Jhund Sarai,Farukhnagar,Gurgaon',
            city: 'Haryana',
            state: '',
            zip: '122505',
            country_name:'印度'

          },
          {
            fbacode: 'SJAB',
            address: '​Plot No. 128 Jhotwara Industrial Area Jaipur',
            city: 'Rajasthan',
            state: '',
            zip: '302016',
            country_name:'印度'

          },
          {
            fbacode: 'AMD1',
            address: 'Crystal Indus Logistics Park ,Unit No.10, National Highway 8th, Bhayla village,Block No.70P, Resurvey No-923, Bawla Taluka, District Ahmedabad',
            city: 'Gujarat',
            state: '',
            zip: '382220',
            country_name:'印度'

          },
          {
            fbacode: 'SCJA',
            address: '​Central Warehouse No.2, Chinnasamynaidu Road, Siddhapudur,Coimbatore',
            city: 'TamilNadu',
            state: '',
            zip: '641044',
            country_name:'印度'

          },
          {
            fbacode: 'SAMC',
            address: 'Plot No.22,Swastik Industrial Estate,Survey No.242,Village Sari,Taluka Sanand District,Ahmedabad',
            city: 'Gujarat',
            state: '',
            zip: '382220',
            country_name:'印度'

          },
          {
            fbacode: 'SBLB',
            address: ' #200, CHICKHULLUR JANGAMAKOTE ROAD, DASARAHALLI POST, HOSKOTE TALUKA, BANGALORE RURAL DISTRICT',
            city: 'Karnataka',
            state: '',
            zip: '562114',
            country_name:'印度'

          },
          {
            fbacode: 'HYD8',
            address: 'Survey no.99/1,Mamidipally Village,Shamshabad,Hyderabad',
            city: 'Telangana',
            state: '',
            zip: '500409',
            country_name:'印度'

          },//20
          {
            fbacode: 'BOM4',
            address: 'WB 10/11, Renaissance Industrial Park, Village Vashere, Post Amane, Taluka Bhiwandi, Dist. Thane',
            city: 'Maharashtra',
            state: '',
            zip: '421302',
            country_name:'印度'

          },
          {
            fbacode: 'SVGA',
            address: 'C/o. Yusen Logistics Pvt. Ltd. Survey Number 36/6 & 36/4B, Done Atkuru Village, Nidamanuru, Vijayawada',
            city: 'Andra Pradesh',
            state: '',
            zip: '521104',
            country_name:'印度'

          },
          {
            fbacode: 'SHYB',
            address: 'A2 and B2,Sy.no 14,14/part& 170,Somaram Village,Medchal Mandal,Medchal',
            city: 'Telangana',
            state: '',
            zip: '501401',
            country_name:'印度'

          },
          {
            fbacode: 'DEL4',
            address: 'KH No 18//21,19//25,34//5,6,7/1 min,14/2/2 min,15/1 min,27,35//1,7,8,9/1,9/2,10/1,10/2,11 min,12,13,14 of village Jamalpur,Dist Gurgaon',
            city: 'Haryana ',
            state: '',
            zip: '122503',
            country_name:'印度'

          },
          {
            fbacode: 'SATB',
            address: 'H.B.No 212,situated in village katani kalan,sub ditrict sahnewal, Dist. Ludhiana',
            city: 'Punjab',
            state: '',
            zip: '141113',
            country_name:'印度'

          },
          {
            fbacode: 'SDED',
            address: 'J-4, block B-1, Mohan Co-operative Industrial estate, Mathura road',
            city: 'New Delhi',
            state: '',
            zip: '110044',
            country_name:'印度'

          },
          {
            fbacode: 'MAA4',
            address: '​Indo Space AS Industrial Park Private Limited, Survey No.139-157/2, Durainallur Village, Puduvoyal Post, Ponneri Taluk, Thiruvallur District',
            city: 'TamilNadu',
            state: '',
            zip: '601 206',
            country_name:'印度'

          },
          {
            fbacode: 'SDEG',
            address: 'Khasra No.58//12/2/2/2 min,19 min,20/2,21/1,21/2,21/3,57//23/2,24,25,63//3/1/1,4/1,5/1,Village Bilaspur,District Gurgaon',
            city: 'Haryana',
            state: '',
            zip: '122413',
            country_name:'印度'

          },
          {
            fbacode: 'DEL3',
            address: 'Agson Global Logistics Park,Village Kishora, Main G.T.Road, Sonipat',
            city: 'Haryana',
            state: '',
            zip: '122413',
            country_name:'印度'

          },
          {
            fbacode: 'BOM5',
            address: 'Renaissance industrial smart city, Kalyan Sape roadVashere village, Amane post',
            city: 'Thane',
            state: '',
            zip: '421302',
            country_name:'印度'

          },// 30
          {
            fbacode: 'SDEA',
            address: 'A-43, Ground Floor, Mohan Cooperative Industrial Estate, Main Mathura Road, Badarpur, South Delhi',
            city: 'New Delhi',
            state: '',
            zip: '110044',
            country_name:'印度'

          },
          {
            fbacode: 'BLR5',
            address: '38 & 39, Soukya Road,  Kacherakanahalli, Hoskote Taluka, Bangalore Rural District',
            city: 'Karnataka',
            state: '',
            zip: '560067',
            country_name:'印度'

          },
          {
            fbacode: 'SATA',
            address: 'M/s Nahar Logistics Park Pvt. Ltd, Khewat No. 79/80 & 39/59, Khasra No. 306,348/305, 48 & 56, Near Katana Sahib Gurudwara, Dist. Ludhiana',
            city: 'Punjab',
            state: '',
            zip: '141113',
            country_name:'印度'

          },
          {
            fbacode: 'SDEH',
            address: 'Khasra Nos.103,106,110 to 155,Village Galand,Pargana Dasana,Tehsil Dhaulana,District Hapur,National Highway',
            city: 'UP',
            state: '',
            zip: '245301',
            country_name:'印度'

          },
          {
            fbacode: 'NAG1',
            address: 'TCI Supply Chain Solutions, Plot no. 3, Khasra No. 104 (Part), 111 (Part), Hingna P.S., Khapri Post Office, Nagpur District',
            city: 'Maharashtra',
            state: '',
            zip: '441108',
            country_name:'印度'

          },
          {
            fbacode: 'SCCA',
            address: 'Kuehne Nagel Pvt. Ltd., Dag No. 8-31, Dag No. 414-425 L R, Khatian No. 871, 798, Mouza-Simla & Pandit Satghara, JL No. 17-18, Shimla, Sreerampore, Hooghly',
            city: 'West Bengal',
            state: '',
            zip: '712203',
            country_name:'印度'

          },
          {
            fbacode: 'SPNA',
            address: 'IndoSpace AS Industrial Park Pvt Ltd, Gat 339, 341, Behind Hotel Marriott, Off MIDC Road, Village Mahalunge Ingle, Landmark - Near Harman Industries, Taluka Khed, Dist Pune',
            city: 'Maharashtra',
            state: '',
            zip: '410501',
            country_name:'印度'

          },
          {
            fbacode: 'SDEF',
            address: '​No. A-33,Mohan Cooperative Industrial Estate ',
            city: 'New Delhi',
            state: '',
            zip: '110044',
            country_name:'印度'

          },
          {
            fbacode: 'SMAB',
            address: 'Shed No.k3, Survey Nos.402/1C2,402/1E2,402/1F2B,402/1G,402/1H,Village Kuthambakkam,Taluka,Poonamalle,District Thiruvallur',
            city: 'TamilNadu',
            state: '',
            zip: '602103',
            country_name:'印度'

          },
          {
            fbacode: 'SLKA',
            address: 'c/o Kuehne Nagel Pvt Limited Bijanaur Peppersand road, Khasara no 543, 544, 537, 540, 541, Near CRPF Camp',
            city: 'UP',
            state: '',
            zip: '226008',
            country_name:'印度'

          },// 40
          {
            fbacode: 'SDEB',
            address: 'Kuehne Nagel Pvt. Ltd, Building No. 2B, M/s. Indospace FWS Industrial Parks Pvt. Ltd., Pataudi-Kulana Road, VPO Luhari, MDR-132, Tehsil Jhajjar, City: Jhajjar',
            city: 'Haryana',
            state: '',
            zip: '124108',
            country_name:'印度'

          },
          {
            fbacode: 'HYD7',
            address: 'SY. NOs 241-244, 275-284, Penjerla (V), Kottur (M), Mahabubnagar dist., Hyderabad',
            city: 'Telangana',
            state: '',
            zip: '509228',
            country_name:'印度'

          },
          {
            fbacode: 'SBLC',
            address: 'Sai Dhara Complex, Warehouse No I-1, Next to Shangrila Resort, TCI supply chain solution ltd, No.92 Anugondanagalli Village & Hobli Hoskote Taluk, Bangalore Rural, Bangalore ',
            city: 'Karnataka',
            state: '',
            zip: '560067',
            country_name:'印度'

          },
          {
            fbacode: 'BOM3',
            address: 'K-Square Industrial and Logistics Park, WH 5/2, Village Kurund, Taluka Bhiwandi, Thane i, Thane',
            city: 'Maharashtra',
            state: '',
            zip: '421302',
            country_name:'印度'

          },
          {
            fbacode: 'SDEE',
            address: 'Plot No. A-28(Lower Ground floor), Mohan Co-operative Industrial Estate, Mathura Road',
            city: 'New Delhi',
            state: '',
            zip: '110044',
            country_name:'印度'

          },//印度
          {
            fbacode: 'MEX3',
            address: 'Manzana 008',
            city: 'Tepotzotlán',
            state: 'State of Mexico',
            zip: '54607',
            country_name:'墨西哥'

          },
          {
            fbacode: 'MEX1',
            address: 'Cam. a Coacalco 11A, Axotlan',
            city: 'Cuautitlán Izcalli',
            state: 'State of Mexico',
            zip: '54715',
            country_name:'墨西哥'

          },
          {
            fbacode: 'MEX',
            address: 'Plot No. A-28(Lower Ground floor), Mohan Co-operative Industrial Estate, Mathura Road',
            city: 'Cuautitlán Izcalli',
            state: 'State of Mexico',
            zip: '54769',
            country_name:'墨西哥'

          },
          {
            fbacode: 'MEX2',
            address: 'Manzana 005',
            city: 'Cuautitlán Izcalli',
            state: 'State of Mexico',
            zip: '54769',
            country_name:'墨西哥'

          },
          {
            fbacode: 'BJX1',
            address: 'Calle Oliver Evans number 107 Carretera a Santa Ana del Conde, Km 4.5',
            city: 'Leon',
            state: 'Guanajuato',
            zip: '37680',
            country_name:'墨西哥'

          },//墨西哥
          {
            fbacode: 'DTM1',
            address: 'Raiffeisenstrasse 7',
            city: 'Werne',
            state: 'Nordrhein-Westfalen',
            zip: '59368',
            country_name:'德国'
          },
          {
            fbacode: 'DE01',
            address: 'Gustav-kunst-str.2-16',
            city: 'Hamburg',
            state: '',
            zip: '20539',
            country_name:'德国'
          },
          {
            fbacode: 'FRA3',
            address: ' Amazonstrasse 1 ',
            city: 'Bad Hersfeld',
            state: 'Hessen',
            zip: '36251',
            country_name:'德国'
          },
          {
            fbacode: 'EDE4',
            address: 'Wahrbrink 25',
            city: 'Werne',
            state: 'Nordrhein-Westfalen',
            zip: '59368',
            country_name:'德国'
          },
          {
            fbacode: 'LEJ3',
            address: 'Bielefelder Strasse 9 ',
            city: 'Sulzetal',
            state: 'Sachsen-Anhalt',
            zip: '39171',
            country_name:'德国'
          },
          {
            fbacode: 'DTM2',
            address: 'Kaltbandstrasse 4 ',
            city: 'Dortmund',
            state: 'Nordrhein-Westfalen',
            zip: '44145',
            country_name:'德国'
          },
          {
            fbacode: 'BER3',
            address: 'Havellandstrasse 5',
            city: 'Brieselang',
            state: 'Brandenburg',
            zip: '14656',
            country_name:'德国'
          },
          {
            fbacode: 'HAJ1',
            address: 'Zur Alten Molkerei 1',
            city: 'Helmstedt',
            state: 'Saxony',
            zip: '38350',
            country_name:'德国'
          },
          {
            fbacode: 'LCJ2-1',
            address: 'Hamburger Str.99',
            city: 'Nuernberg',
            state: 'Bavaria',
            zip: '90451',
            country_name:'德国'
          },
          {
            fbacode: 'MUC3',
            address: 'Amazonstrasse  1',
            city: 'Graben',
            state: 'Bayern',
            zip: '86836',
            country_name:'德国'
          },//10
          {
            fbacode: 'POZ1',
            address: 'Hamburger Str. 99',
            city: 'Nuernberg',
            state: 'Bavaria',
            zip: '90451',
            country_name:'德国'
          },
          {
            fbacode: 'LEJ1',
            address: ' Amazonstrasse 1 ',
            city: 'Leipzig',
            state: 'Sachsen',
            zip: '4347',
            country_name:'德国'
          },
          {
            fbacode: 'XDEV',
            address: 'Groner Siekanger  (Building A/north)',
            city: 'Goettingen',
            state: 'Niedersachsen',
            zip: '37081',
            country_name:'德国'
          },
          {
            fbacode: 'STR2',
            address: 'Oggenhauser Hauptstrasse 151',
            city: 'Heindenheim an der Brenz',
            state: 'Baden Wurttemberg',
            zip: '89522',
            country_name:'德国'
          },
          {
            fbacode: 'XWR1',
            address: 'Hamburger Str. 99',
            city: 'Nürnberg',
            state: 'Bavaria',
            zip: '90451',
            country_name:'德国'
          },
          {
            fbacode: 'XFR2',
            address: 'Industriegebiet Alsberg',
            city: 'Rennerod',
            state: 'Koblenz',
            zip: '56477',
            country_name:'德国'
          },
          {
            fbacode: 'XFR1',
            address: 'Zum Haarstrauch 9-15',
            city: 'Hammersbach',
            state: 'Hesse ',
            zip: '63546',
            country_name:'德国'
          },
          {
            fbacode: 'XWR3',
            address: 'Hamburger Str. 99',
            city: 'Nuernberg',
            state: 'Bavaria',
            zip: '90451',
            country_name:'德国'
          },
          {
            fbacode: 'DUS2',
            address: 'Amazonstrasse 1',
            city: 'Rheinberg',
            state: 'Nordrhein-Westfalen',
            zip: '47495',
            country_name:'德国'
          },
          {
            fbacode: 'XDR1',
            address: 'Hamburger Str.99',
            city: 'Nürnberg',
            state: 'Bavaria',
            zip: '90451',
            country_name:'德国'
          },//20
          {
            fbacode: 'PAD1',
            address: 'Aurea 10',
            city: 'Oelde',
            state: 'Nordrhein-Westfalen',
            zip: '59302',
            country_name:'德国'
          },
          {
            fbacode: 'XDU1',
            address: ' Bornwiese 1',
            city: 'Malsfeld',
            state: 'Hessen ',
            zip: '34323',
            country_name:'德国'
          },
          {
            fbacode: 'DUS4',
            address: 'Hamburgring 10',
            city: 'Mönchengladbach',
            state: 'Nordrhein-Westfalen',
            zip: '41179',
            country_name:'德国'
          },
          {
            fbacode: 'BER6',
            address: 'Am Borsigturm 100',
            city: 'Berlin',
            state: 'Berlin',
            zip: '13507',
            country_name:'德国'
          },
          {
            fbacode: 'XPO1',
            address: 'Hamburger Str. 99',
            city: 'Nuernberg',
            state: 'Bavaria',
            zip: '90451',
            country_name:'德国'
          },
          {
            fbacode: 'CGN1',
            address: 'Amazonstraße 1',
            city: 'Kobern-Gondorf',
            state: 'Rheinland - Pfalz',
            zip: '56330',
            country_name:'德国'
          },
          {
            fbacode: 'LEJ5',
            address: 'Am Steingarten  2',
            city: 'GERA',
            state: 'Thüringen',
            zip: '7554',
            country_name:'德国'
          },
          {
            fbacode: 'LCJ2',
            address: 'Hamburger Str. 99',
            city: 'Nuernberg',
            state: 'Bavaria',
            zip: '90451',
            country_name:'德国'
          },
          {
            fbacode: 'XFR3',
            address: 'Stadtring 265',
            city: 'Michelstadt',
            state: 'Darmstadt',
            zip: '64720',
            country_name:'德国'
          },
          {
            fbacode: 'XDU2',
            address: 'Im Lekkerland 2',
            city: 'Oberhausen',
            state: 'Nordrhein-Westfalen',
            zip: '46147',
            country_name:'德国'
          },//30
          {
            fbacode: 'FRA1',
            address: 'Am Schloß Eichhof 1',
            city: 'Bad Herfeld',
            state: 'Hessen',
            zip: '36251',
            country_name:'德国'
          },
          {
            fbacode: 'HAM2',
            address: 'Borgwardstrasse 10',
            city: 'Winsen (Luhe)',
            state: 'Niedersachsen',
            zip: '21423',
            country_name:'德国'
          },
          {
            fbacode: 'CGN1-1',
            address: 'Amazonstrasse 1',
            city: 'Kobern-Gondorf',
            state: 'Rheinland - Pfalz',
            zip: '56330',
            country_name:'德国'
          },
          {
            fbacode: 'BRE4',
            address: 'Max-Naumann-Strasse 1',
            city: 'Achim',
            state: 'Niedersachsen',
            zip: '28832',
            country_name:'德国'
          },
          {
            fbacode: 'LCJ3',
            address: 'Hamburger Str. 99',
            city: 'Nuernberg',
            state: 'Bavaria',
            zip: '90451',
            country_name:'德国'
          },
          {
            fbacode: 'EDE5',
            address: 'Wahrbrink 23 ',
            city: 'Werne',
            state: 'Nordrhein-Westfalen',
            zip: '59368',
            country_name:'德国'
          },
          {
            fbacode: 'XDEH',
            address: 'Industriegebiet Alsberg',
            city: 'Rennerod',
            state: 'Rheinland-Pfalz',
            zip: '56477',
            country_name:'德国'
          },
          {
            fbacode: 'XGEB',
            address: 'Steinauer Weg 7b',
            city: 'Aurach',
            state: 'Bavaria',
            zip: '91589',
            country_name:'德国'
          },
          {
            fbacode: 'WRO5',
            address: 'Schieferstraße 16',
            city: 'Halle(Saale)',
            state: 'Saxony-Anhalt',
            zip: '6126',
            country_name:'德国'
          },
          {
            fbacode: 'DTM3',
            address: 'Warmbreitbandstraße 3',
            city: 'Dortmund ',
            state: 'North Rhine-Westphalia',
            zip: '44145',
            country_name:'德国'
          },//40
          {
            fbacode: 'DTM2-1',
            address: 'Kaltbandstrasse 4 Dortmund 4',
            city: 'Westphalia',
            state: 'North Rhine-Westphalia',
            zip: '44145',
            country_name:'德国'
          },
          {
            fbacode: 'BER8',
            address: '12529 Schonefeld',
            city: 'Schonefeld',
            state: '',
            zip: '12529',
            country_name:'德国'
          },
          {
            fbacode: 'DTM1-',
            address: ' Carl-Zeiss-Straße 3',
            city: 'Werne',
            state: 'Nordrhein-Westfalen',
            zip: '59368',
            country_name:'德国'
          },
          {
            fbacode: 'FRA7',
            address: 'Am Römig 5 ',
            city: ' Frankenthal',
            state: ' Pfalz',
            zip: '67227',
            country_name:'德国'
          },
          {
            fbacode: 'EDEA',
            address: 'Warmbreitbandstrasse 3 ',
            city: 'Dortmund',
            state: 'North Rhine Westphalia',
            zip: '44145',
            country_name:'德国'
          },
          {
            fbacode: 'STR1',
            address: ' Amazonstrasse 1 ',
            city: 'Pforzheim',
            state: 'Baden-Wurttemberg',
            zip: '75177',
            country_name:'德国'
          },
          {
            fbacode: 'KTW1',
            address: 'Hamburger Str. 99',
            city: 'Nuernberg',
            state: 'Bavaria',
            zip: '90451',
            country_name:'德国'
          },
          {
            fbacode: 'XSC1',
            address: 'Hans-Geiger-Strasse 7',
            city: 'Kaiserslautern',
            state: 'Rheinland-Pfalz',
            zip: '67661',
            country_name:'德国'
          },//德国
          {
            fbacode: 'XMP1',
            address: 'Via Maestri Del Lavoro, 990 ',
            city: 'Arqua Polesine',
            state: 'Rovigo ',
            zip: '45031',
            country_name:'意大利'
          },
          {
            fbacode: 'FCO5',
            address: 'Via di Valle Caia snc',
            city: 'Ardea',
            state: 'Rome',
            zip: '40',
            country_name:'意大利'
          },
          {
            fbacode: 'TRN1',
            address: 'Strada Provinciale per Rondissone 90 ',
            city: 'Torrazza',
            state: 'Piemonte',
            zip: '10037',
            country_name:'意大利'
          },
          {
            fbacode: 'MXP3',
            address: 'Via Rita Levi Montalcini',
            city: 'Vercelli',
            state: 'Vercelli',
            zip: '13100',
            country_name:'意大利'
          },
          {
            fbacode: 'BLQ1',
            address: 'Via Ipazia D’Alessandria 946',
            city: 'San Bellino',
            state: 'Rovigo',
            zip: '45020',
            country_name:'意大利'
          },
          {
            fbacode: 'MXP5',
            address: 'Strada Dogana Po,2U',
            city: 'Castel San Giovanni',
            state: 'Piacenza',
            zip: '29015',
            country_name:'意大利'
          },
          {
            fbacode: 'BLQ8',
            address: 'Via Pelloni 5',
            city: 'Spilamberto',
            state: 'Modena',
            zip: '41057',
            country_name:'意大利'
          },
          {
            fbacode: 'BGY1',
            address: 'Via delle Motte no10 ',
            city: 'Cividate al Piano',
            state: 'BERGAMO',
            zip: '24050',
            country_name:'意大利'
          },
          {
            fbacode: 'XMP4',
            address: 'Zona Industriale Strada per',
            city: 'Casei Gerola',
            state: 'Lombardy',
            zip: '27050',
            country_name:'意大利'
          },
          {
            fbacode: 'FCO1',
            address: 'Via della Meccanica snc 4',
            city: 'Passo Corese',
            state: 'Rieti',
            zip: '2032',
            country_name:'意大利'
          },//10
          {
            fbacode: 'XLI3',
            address: 'Strada Provinciale 128 km 2 Geodis Logistics S.p.A.',
            city: 'Marzano',
            state: 'Pavia',
            zip: '27010',
            country_name:'意大利'
          },
          {
            fbacode: 'XITF',
            address: 'Strada della Torre della Razza 62',
            city: 'Piacenza',
            state: 'Le mose',
            zip: '29100',
            country_name:'意大利'
          },
          {
            fbacode: 'XITC',
            address: 'Via Aldo Moro 4',
            city: 'Francolino di Carpiano',
            state: 'Carpiano',
            zip: '20080',
            country_name:'意大利'
          },
          {
            fbacode: 'MXP6',
            address: 'Strada Provinciale',
            city: 'AGOGNATE',
            state: 'NOVARA',
            zip: '28100',
            country_name:'意大利'
          },
          {
            fbacode: 'XMP2',
            address: 'Via Aldo Moro 4 ',
            city: 'Francolino di Carpiano',
            state: 'Carpiano ',
            zip: '20080',
            country_name:'意大利'
          },
          {
            fbacode: 'PSR2',
            address: 'Viale Germania 29',
            city: 'San Salvo',
            state: 'CH',
            zip: '66050',
            country_name:'意大利'
          },
          {
            fbacode: 'FCO2',
            address: 'Via Palianese',
            city: ' Colleferro',
            state: 'Rome',
            zip: '34',
            country_name:'意大利'
          },//意大利
          {
            fbacode: 'PRG9',
            address: 'U Nové Hospody 1164',
            city: 'Plzeň 3-Skvrňany',
            state: '',
            zip: '30100',
            country_name:'捷克'
          },
          {
            fbacode: 'PRG5',
            address: 'Jezerská',
            city: 'Jirkov-Výdejní místo Vrskmaň',
            state: '',
            zip: '43111',
            country_name:'捷克'
          },
          {
            fbacode: 'PRG14',
            address: 'Sokolovská 115',
            city: 'Praha 8-Invalidovna',
            state: '',
            zip: '18000',
            country_name:'捷克'
          },//捷克
          {
            fbacode: 'SIN8',
            address: '5B Toh Guan Rd E, Level 3',
            city: 'Singapore',
            state: '',
            zip: '608829',
            country_name:'新加坡'
          },//新加坡
          {
            fbacode: 'TPF6',
            address: '松崎台2-4-1',
            city: '印西市',
            state: '千葉県',
            zip: '270-1389',
            country_name:'日本'
          },
          {
            fbacode: 'TYO4',
            address: '末広町2-9-14',
            city: '青梅市',
            state: '東京都',
            zip: '198-8501',
            country_name:'日本'
          },
          {
            fbacode: 'TPX2',
            address: '松崎台2-4-3',
            city: '印西市',
            state: '千葉県',
            zip: '270-1389',
            country_name:'日本'
          },
          {
            fbacode: 'HND3',
            address: '川島町かわじま2-1-1 2F',
            city: '比企郡',
            state: '埼玉県',
            zip: '350-0195',
            country_name:'日本'
          },
          {
            fbacode: 'VJNC ',
            address: '入庫係 東田町5-18 1 F',
            city: '門真市',
            state: '大阪府',
            zip: '571-0034',
            country_name:'日本'
          },
          {
            fbacode: 'XKX2',
            address: '箕輪3-2-61 ニッセイロジスティクスセンター東大阪1F',
            city: '東大阪市',
            state: '大阪府',
            zip: '578-0914',
            country_name:'日本'
          },
          {
            fbacode: 'QCB1',
            address: '西深井字早稲田1603番地1',
            city: '流山市',
            state: '千葉県',
            zip: '270-0196',
            country_name:'日本'
          },
          {
            fbacode: 'KIX1',
            address: '堺区築港八幡町138-7',
            city: '堺市',
            state: '大阪府',
            zip: '590-8589',
            country_name:'日本'
          },
          {
            fbacode: 'XKX1',
            address: '彩都あかね1番地 三井不動産ロジスティクスパーク（MFLP）茨木2F ',
            city: '茨木市',
            state: '大阪府',
            zip: '567-0084',
            country_name:'日本'
          },
          {
            fbacode: 'VJNB',
            address: '東灘区深江浜町65番地グッドマン神戸 3F ナカノ商会',
            city: '神戸市',
            state: '兵庫県',
            zip: '658-0023',
            country_name:'日本'
          },//10
          {
            fbacode: 'TYO6',
            address: '西インター1丁目2-1',
            city: '坂戸市',
            state: '埼玉県',
            zip: '350-0282',
            country_name:'日本'
          },
          {
            fbacode: 'KIX6',
            address: '東海岸町20-1',
            city: '尼崎市',
            state: '兵庫県',
            zip: '660-8582',
            country_name:'日本'
          },
          {
            fbacode: 'VJNA',
            address: '藤ケ谷1823',
            city: '柏市',
            state: '千葉県',
            zip: '277-0931',
            country_name:'日本'
          },
          {
            fbacode: 'TPF3',
            address: '芝生町1-52-2',
            city: '高槻市',
            state: '大阪府',
            zip: '569-8570',
            country_name:'日本'
          },
          {
            fbacode: 'QCB4',
            address: '美浜区新港68番1',
            city: '千葉市',
            state: '千葉県',
            zip: '261-8528',
            country_name:'日本'
          },
          {
            fbacode: 'TYO3',
            address: '四谷5丁目23-62',
            city: '府中市',
            state: '東京都',
            zip: '183-8570',
            country_name:'日本'
          },
          {
            fbacode: 'TPB1',
            address: '小松原2-7-1',
            city: '座間市',
            state: '神奈川県',
            zip: '252-0002',
            country_name:'日本'
          },
          {
            fbacode: 'QCB3',
            address: '広瀬台2-4-3',
            city: '狭山市',
            state: '埼玉県',
            zip: '350-1383',
            country_name:'日本'
          },
          {
            fbacode: 'NRT1',
            address: '塩浜2-13-1',
            city: '市川市',
            state: '千葉県',
            zip: '272-0193',
            country_name:'日本'
          },
          {
            fbacode: 'HND9',
            address: '高津区北見方3-14-1',
            city: '川崎市',
            state: '神奈川県',
            zip: '213-8517',
            country_name:'日本'
          },//20
          {
            fbacode: 'FSZ1',
            address: '扇町4-5-1',
            city: '小田原市',
            state: '神奈川県',
            zip: '250-8560',
            country_name:'日本'
          },
          {
            fbacode: 'HND8',
            address: '石川町2970-3',
            city: '八王子市',
            state: '東京都',
            zip: '192-8560',
            country_name:'日本'
          },
          {
            fbacode: 'TPF9',
            address: '茜浜3丁目7-2 ランドポート習志野 2階',
            city: '習志野市',
            state: '千葉県',
            zip: '275-0024',
            country_name:'日本'
          },
          {
            fbacode: 'TPFB',
            address: '石田100',
            city: '伊勢原市',
            state: '神奈川県',
            zip: '259-1116',
            country_name:'日本'
          },
          {
            fbacode: 'NRT5',
            address: '南台1-10-15',
            city: '川越市',
            state: '埼玉県',
            zip: '350-1182',
            country_name:'日本'
          },
          {
            fbacode: 'TYO9',
            address: '広瀬台4-5',
            city: '狭山市',
            state: '埼玉県',
            zip: '350-1389',
            country_name:'日本'
          },
          {
            fbacode: 'TYO7',
            address: '堤崎大字中新井字前533(MUCD上尾)',
            city: '上尾市',
            state: '埼玉県',
            zip: '362-8508',
            country_name:'日本'
          },
          {
            fbacode: 'TPF2',
            address: '吉見町西吉見480',
            city: '比企郡',
            state: '埼玉県',
            zip: '355-0157',
            country_name:'日本'
          },
          {
            fbacode: 'KIX3',
            address: '松下町2-1',
            city: '茨木市',
            state: '大阪府',
            zip: '567-8507',
            country_name:'日本'
          },
          {
            fbacode: 'VJU1',
            address: '石田100 MFLP厚木Ⅱ',
            city: '伊勢原市',
            state: '伊勢原市',
            zip: '259-1116',
            country_name:'日本'
          },//30
          {
            fbacode: 'TYO1',
            address: '領家5-14-35',
            city: '川口市',
            state: '埼玉県',
            zip: '332-8503',
            country_name:'日本'
          },
          {
            fbacode: 'XHD1',
            address: '石田100 MFLP AtsugiⅡ 1F',
            city: '伊勢原市',
            state: '神奈川県',
            zip: '259-1116',
            country_name:'日本'
          },
          {
            fbacode: 'TPB2',
            address: '堤崎362-1',
            city: '上尾市',
            state: '埼玉県',
            zip: '362-8502',
            country_name:'日本'
          },
          {
            fbacode: 'XHD2',
            address: '領家4丁目9番37号 MFLP川口Ⅰ 1F',
            city: '川口市',
            state: '埼玉県',
            zip: '332-0004',
            country_name:'日本'
          },
          {
            fbacode: 'TPFC',
            address: '新曽南4丁目3 ESR戸田',
            city: '戸田市',
            state: '埼玉県',
            zip: '335-0026',
            country_name:'日本'
          },
          {
            fbacode: 'VJUN',
            address: '吉見町 西吉見 480',
            city: '比企郡',
            state: '埼玉県',
            zip: '355-0157',
            country_name:'日本'
          },
          {
            fbacode: 'KIX5',
            address: '松井宮田1',
            city: '京都府',
            state: '京田辺市',
            zip: '610-0397',
            country_name:'日本'
          },
          {
            fbacode: 'NRT2',
            address: '上高野2036',
            city: '八千代市',
            state: '千葉県',
            zip: '276-8525',
            country_name:'日本'
          },
          {
            fbacode: 'HSG1',
            address: '弥生が丘3-1-3',
            city: '鳥栖市',
            state: '佐賀県',
            zip: '841-8505',
            country_name:'日本'
          },
          {
            fbacode: 'VJND',
            address: '泉 935',
            city: '立川市',
            state: '東京都',
            zip: '190-0015',
            country_name:'日本'
          },//40
          {
            fbacode: 'TYO2',
            address: '上清久字桟敷1000番1',
            city: '久喜市',
            state: '埼玉県',
            zip: '346-8511',
            country_name:'日本'
          },
          {
            fbacode: 'VJNE',
            address: '大神455番1，Dプロジェクト平塚',
            city: '平塚市',
            state: '神奈川県',
            zip: '254-0012',
            country_name:'日本'
          },
          {
            fbacode: 'HND6',
            address: '北見方3-14-1',
            city: '川崎市',
            state: '神奈川县',
            zip: '213-8516',
            country_name:'日本'
          },
          {
            fbacode: 'TPFD',
            address: '八幡カイトリ1-1',
            city: '八幡市',
            state: '京都府',
            zip: '614-8302',
            country_name:'日本'
          },
          {
            fbacode: 'NGO2',
            address: '旭ヶ丘10-6',
            city: '岐阜県 ',
            state: '岐阜県 ',
            zip: '507-8585',
            country_name:'日本'
          },
          {
            fbacode: 'KIX2',
            address: '大東市緑が丘2-1-1',
            city: '大東市',
            state: '大阪府',
            zip: '574-8531',
            country_name:'日本'
          },
          {
            fbacode: 'TPFG',
            address: '堤崎362-1',
            city: '埼玉県',
            state: '上尾市',
            zip: '362-0054',
            country_name:'日本'
          },
          {
            fbacode: 'TPF4',
            address: '奥田大沢町2-1',
            city: '稲沢市',
            state: '愛知県',
            zip: '492-8224',
            country_name:'日本'
          },
          {
            fbacode: 'TYO8',
            address: '中央区田名字白雨台3532-10',
            city: '相模原市',
            state: '神奈川県',
            zip: '252-5220',
            country_name:'日本'
          },
          {
            fbacode: 'TPFI',
            address: '岩槻区浮谷1512番1',
            city: 'さいたま市',
            state: '埼玉県',
            zip: '339-8503',
            country_name:'日本'
          },//日本 50 
          {
            fbacode: 'LYS1',
            address: "RUE AMAZON, ZAC DU PARC D'ACTIVITES VAL BOURGOGNE 1",
            city: 'Sevrey',
            state: 'Saône-et-Loire',
            zip: '71100',
            country_name:'法国'
          },
          {
            fbacode: 'XCD1',
            address: '50 Boulevard de I Europe',
            city: 'Combs-la-ville',
            state: 'Ile de France',
            zip: '77380',
            country_name:'法国'
          },
          {
            fbacode: 'BVA1',
            address: 'Av. du Superbe Orenoque',
            city: 'AMIENS CEDEX',
            state: 'Boves',
            zip: '80337',
            country_name:'法国'
          },
          {
            fbacode: 'XFRN',
            address: '7 rue des Quatres Routes Geodis',
            city: 'St Quentin Fallavier',
            state: 'Auvergne-Rhone-Alpes',
            zip: '38070',
            country_name:'法国'
          },
          {
            fbacode: 'ORY4-1',
            address: 'AVENUE DU CENTRE D’ESSAI EN VOL 20',
            city: 'BRETIGNY SUR ORGE CEDEX',
            state: 'Essonne',
            zip: '91225',
            country_name:'法国'
          },
          {
            fbacode: 'XOS1',
            address: 'Rue de Corbehem 160',
            city: 'Brebieres',
            state: 'Hauts-de-France',
            zip: '62117',
            country_name:'法国'
          },
          {
            fbacode: 'CDFR',
            address: '5 avenue de Guitayne,Zone Industrielle du Courneau',
            city: 'CANEJAN',
            state: 'CANEJAN',
            zip: '33610',
            country_name:'法国'
          },
          {
            fbacode: 'CDG7',
            address: " Parc d'activites des Portes de Senlis 1 avenue Alain",
            city: 'Senlis',
            state: 'Oise',
            zip: '60452',
            country_name:'法国'
          },
          {
            fbacode: 'LYS1-1',
            address: 'Distripole Chalon ZAC Val de Bourgogne - rue Amazon 1',
            city: 'SEVREY CEDEX',
            state: 'Saône-et-Loire',
            zip: '71311',
            country_name:'法国'
          },
          {
            fbacode: 'XOR1',
            address: 'Parc d’activité de l’A5, Rue Denis Papin',
            city: 'Réau',
            state: 'Île-de-France',
            zip: '77550',
            country_name:'法国'
          },//10
          {
            fbacode: 'ETZ2',
            address: 'rue de la Croix de Lorraine 1',
            city: 'Augny',
            state: 'Moselle',
            zip: '57685',
            country_name:'法国'
          },
          {
            fbacode: 'LIL1-1',
            address: '1,Rue Amazon',
            city: 'Lauwin Planque cedex',
            state: 'Nord',
            zip: '59553',
            country_name:'法国'
          },
          {
            fbacode: 'XFRG',
            address: 'XPO Artenay NS 3PL  ZAC du Moulin',
            city: 'Artenay',
            state: 'Loiret',
            zip: '45410',
            country_name:'法国'
          },
          {
            fbacode: 'ORY1',
            address: 'Pole 45,Rue du Champ Rouge 1401',
            city: 'Saran cedex',
            state: 'Loiret',
            zip: '45772',
            country_name:'法国'
          },
          {
            fbacode: 'XOR2',
            address: 'Parc des Chênes Nord 135, Rue du Brisson ZI St Quentin Fallavier ',
            city: 'Satolas-et-Bonce',
            state: 'Isère',
            zip: '38290',
            country_name:'法国'
          },
          {
            fbacode: 'VESK',
            address: '7 rue du Chrome',
            city: 'Savigny le Temple',
            state: 'Ile de France',
            zip: '77176',
            country_name:'法国'
          },
          {
            fbacode: 'MRS1',
            address: 'Bâtiment 2 Rue Joseph Lagarde ZAC Les Portes de Provence',
            city: 'Montélimar',
            state: 'Drôme',
            zip: '26200',
            country_name:'法国'
          },
          {
            fbacode: 'BVA1-1',
            address: 'Av. du Superbe Orenoque 1',
            city: 'AMIENS CEDEX',
            state: 'Boves',
            zip: '80440',
            country_name:'法国'
          },
          {
            fbacode: 'XOR3',
            address: 'Avenue Louis Renault, ZAC du Val Breon',
            city: 'Chatres',
            state: 'Ile de France',
            zip: '77610',
            country_name:'法国'
          },
          {
            fbacode: 'XFRJ',
            address: '7 rue du Chrome',
            city: 'Savigny le Temple',
            state: 'lle de France',
            zip: '77176',
            country_name:'法国'
          },//20
          {
            fbacode: 'XVA1',
            address: '5 Rue Henri Guillaumet CEVA Logistics',
            city: 'Bussy-Lettree',
            state: 'Marne',
            zip: '51320',
            country_name:'法国'
          },
          {
            fbacode: 'ORY4',
            address: 'AVENUE DU CENTRE D’ESSAI EN VOL 20',
            city: 'BRETIGNY SUR ORGE',
            state: 'Essonne',
            zip: '91220',
            country_name:'法国'
          },
          {
            fbacode: 'ORY1-1',
            address: 'Rue du Champ Rouge 1401',
            city: 'SARAN',
            state: 'Loiret',
            zip: '45770',
            country_name:'法国'
          },
          {
            fbacode: 'LIL8',
            address: 'rue de la Plaine 2',
            city: 'LAUWIN PLANQUE',
            state: 'CEDEX',
            zip: '59553',
            country_name:'法国'
          },
          {
            fbacode: 'MRS1-1',
            address: 'Building II ZAC Les Portes de Provence',
            city: 'MONTELIMAR CEDEX',
            state: 'Drôme',
            zip: '26132',
            country_name:'法国'
          },
          {
            fbacode: 'LIL1',
            address: 'Rue Amazon 1',
            city: 'Lauwin-Planque',
            state: 'Nord',
            zip: '59553',
            country_name:'法国'
          },
          {
            fbacode: 'CDG7-1',
            address: 'avenue Alain Boucher',
            city: 'Senlis Cedex',
            state: 'Oise',
            zip: '60452',
            country_name:'法国'
          },//法国
          {
            fbacode: 'WRO2',
            address: 'Amazon Fulfillment Poland sp. z o o. Ul. Logistyczna 6',
            city: 'Bielany Wroclawskie',
            state: '',
            zip: '55-040',
            country_name:'波兰'
          },
          {
            fbacode: 'WRO1',
            address: 'Amazon Fulfillment Poland sp. z o o., Ul. Czekoladowa 1',
            city: 'Bielany Wroclawskie',
            state: '',
            zip: '55-040',
            country_name:'波兰'
          },
          {
            fbacode: 'SZZ1',
            address: 'Kołbaskowo 156',
            city: 'Szczecin',
            state: '',
            zip: '72-001',
            country_name:'波兰'
          },//波兰
          {
            fbacode: 'XAU2',
            address: 'Warehouse A, Berry Street, Granville',
            city: 'Sydney',
            state: 'NSW',
            zip: '2142',
            country_name:'澳大利亚'
          },
          {
            fbacode: 'XAU1',
            address: 'Warehouse B, 25-29 Jets Court',
            city: 'Tullamarine',
            state: 'Victoria',
            zip: '3043',
            country_name:'澳大利亚'
          },
          {
            fbacode: 'MEL5',
            address: '103 Palm Springs Road',
            city: 'RAVENHALL',
            state: 'VIC',
            zip: '3023',
            country_name:'澳大利亚'
          },
          {
            fbacode: 'BWU2',
            address: '13 Emporium Avenue',
            city: 'Kemps Creek',
            state: 'NSW',
            zip: '2178',
            country_name:'澳大利亚'
          },
          {
            fbacode: 'BWU1',
            address: '23 Centenary Ave',
            city: 'Moorebank',
            state: 'NSW',
            zip: '2170',
            country_name:'澳大利亚'
          },
          {
            fbacode: 'BNE1',
            address: '42-52 EXPORT STREET',
            city: 'LYTTON',
            state: 'QLD',
            zip: '4178',
            country_name:'澳大利亚'
          },
          {
            fbacode: 'PER2',
            address: '60 Paltridge Road',
            city: 'Perth Airport',
            state: 'WA',
            zip: '6105',
            country_name:'澳大利亚'
          },
          {
            fbacode: 'MEL1',
            address: '29 National Drive',
            city: 'Dandenong South',
            state: 'VTC',
            zip: '3175',
            country_name:'澳大利亚'
          },
          {
            fbacode: 'PER3',
            address: 'AFTX FC (Perth, AU) 60 Paltridge Road',
            city: 'PERTH AIRPORT',
            state: 'WA',
            zip: '6105',
            country_name:'澳大利亚'
          },
          {
            fbacode: 'PER4',
            address: 'Site 516 2 Centurion Pl',
            city: 'Jandakot',
            state: 'WA',
            zip: '6164',
            country_name:'澳大利亚'
          },//澳大利亚
          {
            fbacode: 'MPCH',
            address: 'Bankfield Enterprise Hub,Ground Floor ,32 Bankfield Street ',
            city: 'Bootle',
            state: 'Merseyside',
            zip: 'L208EJ',
            country_name:'英国'
          },
          {
            fbacode: 'EUKB',
            address: 'Unit 12, Overton Park, Holkham Road',
            city: 'Peterborough',
            state: '',
            zip: 'PE2 6TE',
            country_name:'英国'
          },
          {
            fbacode: 'LBA2',
            address: 'Unit 1 (IP1= Amazon) Iport Avenue',
            city: 'Doncaster',
            state: 'Yorkshire and the Humber',
            zip: 'DN11 0BG',
            country_name:'英国'
          },
          {
            fbacode: 'XLT2',
            address: 'Unit 12, Holkham Road, Overton Park',
            city: 'PETERBOROUGH',
            state: 'Cambridgeshire',
            zip: 'PE2 6TE',
            country_name:'英国'
          },
          {
            fbacode: 'EDI4',
            address: 'Amazon Way Dunfermline',
            city: 'Dunfermline',
            state: '',
            zip: 'KY11 8ST',
            country_name:'英国'
          },
          {
            fbacode: 'XBH7',
            address: 'Fortress Way Suffolk Park',
            city: 'BURY ST. EDMUNDS',
            state: 'Suffolk',
            zip: 'IP32 7FQ',
            country_name:'英国'
          },
          {
            fbacode: 'XBH4',
            address: 'GRAVELLY WAY CEVA Logistics',
            city: 'WOLVERHAMPTON',
            state: 'West Midlands',
            zip: 'WV10 7GW',
            country_name:'英国'
          },
          {
            fbacode: 'XLP1',
            address: 'Deeside Industrial Park, Zone 3',
            city: 'DEESIDE',
            state: 'Flintshire',
            zip: 'CH5 2LL',
            country_name:'英国'
          },
          {
            fbacode: 'LTN7',
            address: 'Bedford 405, Bedford  Commercial Park',
            city: 'Bedfordshire',
            state: 'BEDFORD',
            zip: 'MK43 9JH',
            country_name:'英国'
          },
          {
            fbacode: 'LTN2-1',
            address: 'Boundary Way',
            city: 'Hertfordshire',
            state: 'Hemel Hempstead ',
            zip: 'HP2 7UJ',
            country_name:'英国'
          },//10
          {
            fbacode: 'BHX4-1',
            address: 'Plot 1, Lyons Park,Coundon Wedge Drive',
            city: 'Coventry',
            state: 'West Midlands',
            zip: 'CV5 9DQ',
            country_name:'英国'
          },
          {
            fbacode: 'EMA1-1',
            address: ' DC1 Pro Logis, Central Park',
            city: 'Warwickshire ',
            state: 'RUGBY ',
            zip: 'CV23 0WB',
            country_name:'英国'
          },
          {
            fbacode: 'LPL2',
            address: 'Unit 1 Marl Road',
            city: 'LIVERPOOL',
            state: 'Lancashire',
            zip: 'L33 7AP',
            country_name:'英国'
          },
          {
            fbacode: 'BHX3-1',
            address: '4 Royal Oak Way North Daventry',
            city: 'Northamptonshire',
            state: '',
            zip: 'NN11 8PQ',
            country_name:'英国'
          },
          {
            fbacode: 'DSA7',
            address: 'Wakefield 515, Grovehall Lane',
            city: 'KNOTTINGLEY',
            state: 'West Yorkshire',
            zip: 'WF11 0AB',
            country_name:'英国'
          },
          {
            fbacode: 'LTN9',
            address: 'UNITS DC1 AND DC2 PROLOGIS BOSCOMBE ROAD',
            city: 'DUNSTABLE ',
            state: '',
            zip: 'LU5 4FE',
            country_name:'英国'
          },
          {
            fbacode: 'MAN1',
            address: '6 Sunbank Lane Airport City Altrincham',
            city: 'Manchester',
            state: '',
            zip: 'M90 5AA',
            country_name:'英国'
          },
          {
            fbacode: 'CWL1',
            address: 'Ffordd Amazon  Swansea，  Wales',
            city: 'Swansea',
            state: 'Wales',
            zip: 'SA1 8QX',
            country_name:'英国'
          },
          {
            fbacode: 'EUKD',
            address: 'Amazon Fulfillment CenterFoundry Point, Halebank Industrial Estate,Foundry Lane',
            city: 'Widnes',
            state: 'Cheshire',
            zip: 'WA8 8YN',
            country_name:'英国'
          },
          {
            fbacode: 'BHX3',
            address: '4 Royal Oak Way North Daventry',
            city: 'Northamptonshire ',
            state: '',
            zip: 'NN11 8QL',
            country_name:'英国'
          },//20
          {
            fbacode: 'BHX4',
            address: 'Plot 1, Lyons Park,Coundon Wedge Drive',
            city: 'Coventry',
            state: 'West Midlands',
            zip: 'CV5 9FA',
            country_name:'英国'
          },
          {
            fbacode: 'MAN3-1',
            address: '360 Logistics North, Over Hulton Bolton',
            city: 'Manchester',
            state: 'North West',
            zip: 'BL5 1EE',
            country_name:'英国'
          },
          {
            fbacode: 'SUUK',
            address: '115 Worship Street',
            city: 'London',
            state: '',
            zip: 'EC2A 2BA',
            country_name:'英国'
          },
          {
            fbacode: 'EUK5',
            address: 'Phase Two, Kingston Park Flaxley Road',
            city: 'Peterborough',
            state: '',
            zip: 'PE2 9EN',
            country_name:'英国'
          },
          {
            fbacode: 'BHX1',
            address: 'Towers Business Park Power Station Road',
            city: 'RUGELEY',
            state: '',
            zip: 'WS15 1LX',
            country_name:'英国'
          },
          {
            fbacode: 'XPL1',
            address: 'Foundry Point, Halebank Industrial Estate Foundry Lane',
            city: 'WIDNES',
            state: 'Cheshire',
            zip: 'WA8 8YN',
            country_name:'英国'
          },
          {
            fbacode: 'XUKS',
            address: 'CEVA Logistics Unit 11, Wilders Way',
            city: 'Derby',
            state: 'Leicestershire',
            zip: 'DE74 2XL',
            country_name:'英国'
          },
          {
            fbacode: 'EUKD-1',
            address: 'Foundry Point, Halebank Industrial Estate',
            city: 'Foundry Lane',
            state: 'Widnes',
            zip: 'WA8 8WJ',
            country_name:'英国'
          },
          {
            fbacode: 'MAN4',
            address: '29 Gander Lane  CHESTERFIELD',
            city: 'Derbyshire',
            state: '',
            zip: 'S43 4PZ',
            country_name:'英国'
          },
          {
            fbacode: 'BHX4-2',
            address: 'Plot 1, Lyons Park, Sayer Dr',
            city: 'Coventry',
            state: 'West Midlands',
            zip: 'CV5 9PF',
            country_name:'英国'
          },//30
          {
            fbacode: 'XUKD',
            address: 'XPO Logistics,Unit A Daventry Distribution Centre',
            city: 'DAVENTRY',
            state: '',
            zip: 'NN11 8LR',
            country_name:'英国'
          },
          {
            fbacode: 'LTN2',
            address: 'Boundary Way Hemel Hempstead Hertfordshire',
            city: 'Hemel Hempstead',
            state: 'Hertfordshire',
            zip: 'HP27LF',
            country_name:'英国'
          },
          {
            fbacode: 'MAN2',
            address: 'Omega Plot 7c Orion Boulevard',
            city: 'Warrington',
            state: 'North West England',
            zip: 'WA5 3XA',
            country_name:'英国'
          },
          {
            fbacode: 'LBA4',
            address: 'Unit IP9 Toronto Way',
            city: 'New Rossington',
            state: 'DONCASTER',
            zip: 'DN11 0BF',
            country_name:'英国'
          },
          {
            fbacode: 'BHX8',
            address: 'Unit A, Gateway, Coventry Hwy',
            city: 'REDDITCH',
            state: '',
            zip: 'B98 9AY',
            country_name:'英国'
          },
          {
            fbacode: 'EUKA',
            address: 'UNO UK，Units 9-10 Manasty Rd',
            city: 'ORTON SOUTHGATE',
            state: '',
            zip: 'PE2 6UG',
            country_name:'英国'
          },
          {
            fbacode: 'BHX5',
            address: 'Unit 3 Rugby',
            city: 'West Midlands',
            state: '',
            zip: 'CV23 0XF',
            country_name:'英国'
          },
          {
            fbacode: 'BHX2-1',
            address: '15B Beveridge Ln',
            city: 'COALVILLE',
            state: 'Leicestershire',
            zip: 'LE67 1FB',
            country_name:'英国'
          },
          {
            fbacode: 'LTN1',
            address: 'Amazon.co.uk Marston Gate Fulfillment Centre Ridg',
            city: 'Ridgmont',
            state: 'Bedfordshire',
            zip: 'MK43 0ZA',
            country_name:'英国'
          },
          {
            fbacode: 'MME1',
            address: 'Building Oneton',
            city: 'Darlington',
            state: 'England',
            zip: 'DL1 4BF',
            country_name:'英国'
          },//40
          {
            fbacode: 'BRS1',
            address: 'Goldcrest Way Bristol, South West',
            city: 'Bristol',
            state: '',
            zip: 'BS35 4DJ',
            country_name:'英国'
          },
          {
            fbacode: 'XUKA',
            address: 'Whitehouse Industrial Estate, Aston Lane North Preston Brook',
            city: 'Runcorn',
            state: 'Cheshire',
            zip: 'WA7 3BN',
            country_name:'英国'
          },
          {
            fbacode: 'MAN3',
            address: '360 Logistics North, Over Hulton Bolton',
            city: 'Manchester',
            state: 'Hulton Bolton',
            zip: 'BL5 1BT',
            country_name:'英国'
          },
          {
            fbacode: 'LTN4',
            address: 'Unit DC1 (Prologis) Boscombe Road',
            city: 'Dunstable',
            state: '',
            zip: 'LU54FE',
            country_name:'英国'
          },
          {
            fbacode: 'GLA1',
            address: '2 Cloch Road Faulds Park',
            city: 'Gourock',
            state: 'Inverclyde',
            zip: 'PA19 1BQ',
            country_name:'英国'
          },
          {
            fbacode: 'MME2',
            address: 'PEAT EDGE FARM TURSDALE ROAD',
            city: 'BOWBURN',
            state: 'North East',
            zip: 'DH6 5NP',
            country_name:'英国'
          },
          {
            fbacode: 'EMA2-1',
            address: 'SUMMIT PARK SHERWOOD WAY',
            city: 'SOUTH SUTTON  IN ASHFIELD',
            state: 'Mansfield',
            zip: 'NG17 4PA',
            country_name:'英国'
          },
          {
            fbacode: 'LCY2',
            address: 'Amazon Distribution Depot Unit 2, London Distribution Park',
            city: 'Tilbury',
            state: '',
            zip: 'RM18 7AN',
            country_name:'英国'
          },
          {
            fbacode: 'LBA1',
            address: 'Unit 1 Balby Carr bank',
            city: 'DONCASTER',
            state: '',
            zip: 'DN4 5JS',
            country_name:'英国'
          },
          {
            fbacode: 'EUKC',
            address: 'Unit 1, Balby Carr bank',
            city: 'Doncaster',
            state: '',
            zip: 'DN4 5JS',
            country_name:'英国'
          },//英国 50 
          {
            fbacode: 'BCN2',
            address: 'Carrer de la VERNEDA 22',
            city: 'MARTORELLES',
            state: 'MARTORELLES',
            zip: '8107',
            country_name:'西班牙'
          },
          {
            fbacode: 'PESG',
            address: 'CEVA Logistics Avenida Hontalba 6',
            city: 'Illescas',
            state: 'Toledo',
            zip: '45200',
            country_name:'西班牙'
          },
          {
            fbacode: 'BCN1',
            address: 'Av. de les Garrigues 6-8',
            city: 'El Prat de Llobregat',
            state: 'Barcelona',
            zip: '8820',
            country_name:'西班牙'
          },
          {
            fbacode: 'ZAZ1',
            address: 'Parcelas: ALI-28 y ALI-2',
            city: 'Zaragoza',
            state: 'Aragon',
            zip: '50197',
            country_name:'西班牙'
          },
          {
            fbacode: 'SVQ1',
            address: 'Poligono Sen',
            city: 'Dos Hermanas Seville',
            state: 'Andalusia',
            zip: '41703',
            country_name:'西班牙'
          },
          {
            fbacode: 'MAD4',
            address: 'Avenida de la Astronomia 24',
            city: 'San Fernando de Henares',
            state: 'Madrid',
            zip: '28830',
            country_name:'西班牙'
          },
          {
            fbacode: 'XMA3',
            address: 'P.I. Dehesa de la Plata 1',
            city: 'Ontigola',
            state: 'Toledo',
            zip: '45340',
            country_name:'西班牙'
          },
          {
            fbacode: 'XESB',
            address: 'ES FBA FLEX Avenida Rio Henares 16',
            city: 'Guadalajara',
            state: 'Alovera',
            zip: '19208',
            country_name:'西班牙'
          },
          {
            fbacode: 'BCN8',
            address: "Carrer Ca n'Alzina, 161",
            city: 'Sabadell',
            state: 'Barcelona',
            zip: '8210',
            country_name:'西班牙'
          },//10
          {
            fbacode: 'MAD7',
            address: 'C. Ancora, 35',
            city: 'Illescas',
            state: 'Toledo',
            zip: '45200',
            country_name:'西班牙'
          },
          {
            fbacode: 'RMU1',
            address: 'Calle Isidro Vivancos Munoz Parque Logistico del Sureste',
            city: 'Murcia',
            state: 'Murcia',
            zip: '30156',
            country_name:'西班牙'
          },
          {
            fbacode: 'VLC1',
            address: 'Calle Panama 28',
            city: 'Onda',
            state: 'Castellon',
            zip: '12200',
            country_name:'西班牙'
          },
          {
            fbacode: 'MAD6',
            address: 'Avenida de la Logistica 13',
            city: 'illescas',
            state: 'Toledo',
            zip: '45200',
            country_name:'西班牙'
          },
          {
            fbacode: 'XESA',
            address: 'AVDEL RIO HENARES 16',
            city: 'Alovera',
            state: 'Guadalajara',
            zip: '19208',
            country_name:'西班牙'
          },
          {
            fbacode: 'MAD9',
            address: 'Camino de los Afligidos',
            city: 'Alcala de Henares',
            state: 'Madrid',
            zip: '28804',
            country_name:'西班牙'
          },//西班牙
      ]
    }
  },
  methods: {
    handleClick(tab, event) {
        console.log(tab, event);
      },
      setActive(item,index) {
        if(index === 0){
          this.$router.push({
            name:'platform'
          })
        }
        else if(index === 1){
          this.$router.push({
            name:'AMAZON'
          })
          // this.$router.push({
          //   name:'warehouseMap'
          // })
        }
        // else if(index === 2){
        //   this.$router.push({
        //     name:'AMAZON'
        //   })
        // }
        // this.activeIndex = index;
        
  
      },
    goClient(){
      window.location.href=  `http://home.szaaf.com:80/#/home/index`
    }
  }
};
</script>
<style src="./index.css" scoped></style>